import type { Hearing } from "@/lib/public-hearings/types";

// Affected wards as richer councillor cards. Ward number sits in a
// mono stamp; the councillor's name reads in Garamond italic next to
// it. The whole card is the calgary.ca link (when available), so the
// click target is generous. Vacant seats flip to amber to surface
// representation gaps.
export function WardsSection({
  wardCouncillors,
  dmapUrls,
}: {
  wardCouncillors: Hearing["wardCouncillors"];
  dmapUrls: Hearing["dmapUrls"];
}) {
  if (wardCouncillors.length === 0) return null;
  const dmap = dmapUrls[0];

  return (
    <section className="ph-detail-panel" aria-label="Affected wards">
      <h2 className="ph-detail-panel-l">
        <span>
          Affected ward{wardCouncillors.length === 1 ? "" : "s"}
        </span>
        <span className="count">{wardCouncillors.length}</span>
      </h2>
      {dmap && (
        <p className="ph-detail-ward-dmap">
          See where the site sits within{" "}
          {wardCouncillors.length === 1 ? "this ward" : "these wards"} on{" "}
          <a
            href={dmap}
            target="_blank"
            rel="noreferrer"
            className="ph-detail-prose-link"
          >
            DMAP
          </a>
          , the City of Calgary&rsquo;s development map.
        </p>
      )}
      <div className="ph-detail-affected">
        {wardCouncillors.map((c) => {
          const vacant = c.status === "vacant";
          const inner = (
            <>
              <span className="ph-detail-ward-stamp">Ward {c.ward}</span>
              <span className="ph-detail-ward-name">
                <span className="pre">
                  {vacant ? "Seat" : "Councillor"}
                </span>
                {vacant ? "currently vacant" : c.name ?? "—"}
              </span>
            </>
          );
          if (c.calgaryCaUrl && !vacant) {
            return (
              <a
                key={`ward-${c.ward}`}
                href={c.calgaryCaUrl}
                target="_blank"
                rel="noreferrer"
                className="ph-detail-ward-card"
                data-vacant="no"
                title={`Ward ${c.ward} councillor — calgary.ca`}
              >
                {inner}
              </a>
            );
          }
          return (
            <div
              key={`ward-${c.ward}`}
              className="ph-detail-ward-card"
              data-vacant={vacant ? "yes" : "no"}
            >
              {inner}
            </div>
          );
        })}
      </div>
    </section>
  );
}
